"use client";

import {
  DayPicker,
  getDefaultClassNames,
  type ClassNames,
} from "react-day-picker";

import {
  CALENDAR_CLASS_MAP,
  CALENDAR_DEFAULTS,
  type TCalendarProps,
} from "@/ui/components/form/Calendar/Calendar.config";
import { CalendarChevron } from "@/ui/components/form/Calendar/CalendarChevron";
import {
  CalendarDayButton,
} from "@/ui/components/form/Calendar/CalendarDayButton";
import { CalendarRoot } from "@/ui/components/form/Calendar/CalendarRoot";
import {
  CalendarWeekNumber,
} from "@/ui/components/form/Calendar/CalendarWeekNumber";
import { cn } from "@/ui/lib/utils";

export const Calendar = ({
  captionLayout = CALENDAR_DEFAULTS.captionLayout,
  className,
  classNames,
  components,
  formatters,
  locale,
  showOutsideDays = CALENDAR_DEFAULTS.showOutsideDays,
  ...props
}: TCalendarProps) => {
  const defaultClassNames = getDefaultClassNames();
  const mergedClassNames = Object.fromEntries(
    Object.entries(defaultClassNames).map(([ key, defaultClassName ]) => [
      key,
      cn(
        defaultClassName,
        CALENDAR_CLASS_MAP[key as keyof typeof CALENDAR_CLASS_MAP],
        classNames?.[key as keyof ClassNames],
      ),
    ]),
  ) as ClassNames;

  return (
    <DayPicker
      {...props}
      locale={locale}
      showOutsideDays={showOutsideDays}
      captionLayout={captionLayout}
      className={className}
      classNames={mergedClassNames}
      formatters={{
        formatMonthDropdown: (date) => date.toLocaleString("default", {
          month: "short",
        }),
        ...formatters,
      }}
      components={{
        Root: CalendarRoot,
        Chevron: CalendarChevron,
        DayButton: CalendarDayButton,
        WeekNumber: CalendarWeekNumber,
        ...components,
      }}
    />
  );
};

Calendar.displayName = "Calendar";
